var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on: tooltip }){return [_c('v-btn',_vm._g({class:_vm.buttonClass,attrs:{"small":"","color":"red"},on:{"click":_vm.handleClick}},tooltip),[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.tooltipText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }